/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `This item has no description.`
};

const fr_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Cet élément n'a pas de description.`
};

const de_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Dieses Element hat keine Beschreibung.`
};

const es_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Este artículo no tiene descripción.`
};

const it_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `Questo articolo non ha descrizione.`
};

const ar_collection_empty_description_text30 = /** @type {(inputs: {}) => string} */ () => {
	return `لا يوجد وصف لهذا العنصر.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const collection_empty_description_text30 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.collection_empty_description_text30(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("collection_empty_description_text30", locale)
	if (locale === "en") return en_collection_empty_description_text30(inputs)
	if (locale === "fr") return fr_collection_empty_description_text30(inputs)
	if (locale === "de") return de_collection_empty_description_text30(inputs)
	if (locale === "es") return es_collection_empty_description_text30(inputs)
	if (locale === "it") return it_collection_empty_description_text30(inputs)
	return ar_collection_empty_description_text30(inputs)
};
export { collection_empty_description_text30 as "COLLECTION_EMPTY_DESCRIPTION_TEXT" }